import { css } from 'emotion';

const previewContainer = (theme, loading) => css`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  overflow: scroll;
  background-color: ${theme.color.black1}e6;

  ${loading
    && css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}
`;

const certificateContainer = open => css`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  ${open
    && css`
      margin-top: -50px;
    `}
`;

const tabWrapper = () => css`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 0px;
  padding: 20px;
  position: fixed;
  top: 0;
  width: 100%;
`;

const tabInnerWrapper = (theme, tabWidth) => css`
  position: relative;
  background: ${theme.color.white};
  max-width: ${tabWidth}px;
  margin: 0 auto;
  padding: 48px 36px;
  margin-top: 90px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
`;

const tabInnerHeader = theme => css`
  min-width: 166px;
  height: 29px;
  font-family: ProximaNova;
  font-size: 24px;
  text-align: left;
  margin-bottom: 20px;
  color: ${theme.color.black1};
`;

const tabInnerInstruction = theme => css`
  margin-bottom: 12px;
  height: 20px;
  font-family: ProximaNova;
  font-size: 16px;
  text-align: left;
  color: ${theme.color.black1};
`;

const linkStyle = theme => css`
  line-height: 44px;
  font-size: 16px;
  letter-spacing: normal;
  color: ${theme.color.black1};
  width: 604px;
  height: 44px;
  border-radius: 2px;
  background-color: #ffffff;
  border: 1px solid ${theme.color.grey2};
  padding-left: 5px;
`;

const tabInnerDetails = () => css`
  display: flex;
  margin-bottom: 8px;
`;

const tabInnerDetailsContent = (theme, highlight) => css`
  min-width: 185px;
  height: 20px;
  font-family: ProximaNova;
  font-size: 16px;
  text-align: left;
  color: ${theme.color.black1};

  ${highlight
    && css`
      font-weight: bold;
    `}
`;

const certificateCloseButton = () => css`
  margin: 0px auto;
  cursor: pointer;
  position: absolute;
  right: 0;
  top: -35px;
`;

export default {
  previewContainer,
  certificateContainer,
  tabInnerDetailsContent,
  linkStyle,
  tabInnerInstruction,
  tabInnerHeader,
  tabInnerWrapper,
  tabWrapper,
  tabInnerDetails,
  certificateCloseButton
};
